<template>
  <v-container fluid>
    <v-app-bar
      app
      color="primary"
      dark
      extension-height="64"
    >
      <v-row>
        <v-col cols="4" class="py-0">
          <v-text-field prepend-icon="mdi-magnify" v-model="baseSearchInput" @keyup="onSearchChange"
                        hide-details></v-text-field>
        </v-col>
        <v-col cols="4" class="py-0">
          <div class="text-center">
            <v-pagination
              v-model="page"
              :length="Math.ceil(basesFiltered.length / pageSize)"
              :total-visible="7"
            ></v-pagination>
          </div>
        </v-col>
        <v-col cols="4" class="py-0" align="right">
          <v-btn icon :color="expanded ? 'green' : 'white'" @click="expanded = !expanded">
            <v-icon>mdi-filter</v-icon>
          </v-btn>
          <div v-if="saving">
            <v-progress-circular color="green" indeterminate></v-progress-circular>
            Saving
          </div>
        </v-col>
      </v-row>
      <template v-slot:extension v-if="expanded">
        <v-row>
          <v-col cols="1" class="pt-5">
            Filters:
          </v-col>
          <v-col cols="3">
            <v-select label="Difficulty" :items="difficulties" v-model="filter.difficulty" hide-details/>
          </v-col>
          <v-col cols="3">
            <strong>Days of wipe:</strong>
            <v-btn-toggle
              color="green"
              v-model="filter.daysOfWipe"
              multiple
            >
              <v-btn small v-for="day in days" :key="day">
                {{ day }}
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col cols="3" class="pt-5">
            <v-checkbox label="Autospawn Enabled" v-model="filter.autospawnEnabled" @change="save(base)"
                        hide-details></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-btn @click="clearFilter()">Clear Filters</v-btn>
          </v-col>
        </v-row>
      </template>
    </v-app-bar>
    <v-row>
      <v-col>
        <v-card dark>
          Test
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // import VueApexCharts from "vue-apexcharts";

  import {mapGetters} from "vuex";
  import AppBar from "@/components/AppBar";
  import moment from "moment";

  export default {
    components: {AppBar},
    computed: {
      ...mapGetters(["currentUser", "config", "configLoading"]),
    },
    props: {
      source: String,
    },
    data: () => ({
    }),
    mounted() {
      this.$store.dispatch("loadConfig");
    },
    methods: {
      clearFilter() {
        console.log(this.filter);
        this.filter.dayOfWipe = [];
        this.filter.difficulty = null;
        this.filter.autospawnEnabled = false;
      },
      onSearchChange() {
        clearTimeout(this.searchDebounce);
        this.searchDebounce = setTimeout(() => {
          this.page = 1;
          this.baseSearch = this.baseSearchInput
        }, 500);
        requestAnimationFrame(x);
      },
      filesChange(base) {
        let formData = new FormData();

        formData.append("file", base.file);
        delete base.file;
        formData.append("id", base.id);

        this.$store.dispatch("saveBaseImage", formData).then(() => {
          this.saving = false;
          this.changeImage = -1;
          this.$store.dispatch("loadBases");
        });
      },
      deleteBase(base) {
        this.$swal({
          title: 'Are you sure you want to delete this base?',
          showCancelButton: true,
          confirmButtonText: `Delete`,
        }).then((result) => {
          console.log(result);
          /* Read more about isConfirmed, isDenied below */
          if (result.value == true) {
            this.saving = true;
            this.$store.dispatch("deleteBase", base).then(() => {
              this.saving = false;
              this.$store.dispatch("loadBases");
            });
          }
        })
      },
      save(base) {
        console.log(base);
        this.saving = true;
        this.$store.dispatch("saveBase", base).then(() => {
          this.saving = false;
          this.$store.dispatch("loadBases");
        });
      },
    },
  };
</script>
